import React from 'react'

export default function Contact() {
    return (
        <div>
            <h1>Contact Me</h1>
        </div>
    )
}
